import React, { Component } from 'react'
import { ThemeProvider } from 'styled-components'
import { theme } from './theme_data'

import GlobalStyle from './GlobalStyle'
import deprecatedPropType from 'helpers/deprecatedPropType'
import PropTypes from 'prop-types'
import { ConfigProvider as AntdConfigProvider } from 'antd';
import { antd_theme } from './antd/antd_theme';
import { mobile_sizes } from './mobile_sizes';


export default class Theme extends Component {
  state = {
    is_keyboard_user: false,
    is_mouse_user: true,

    ...mobile_sizes(),
  }

  render () {
    const {
      is_widget,
      props: {
        contain_styles_in_css_id,
        children
      },
    } = this

    return (
      <ThemeProvider {...{
        theme: {
          ...theme,
          antd: { ...antd_theme },
          ...this.state
        }
      }}>
        <GlobalStyle
          is_widget={is_widget}
          contain_styles_in_css_id={contain_styles_in_css_id}
        />
        <AntdConfigProvider theme={antd_theme}>
          {children}
        </AntdConfigProvider>
      </ThemeProvider>
    )
  }

  componentDidMount () {
    window.addEventListener('keydown', this.keyboardListener)
    window.addEventListener('click', this.mouseListener)
    window.addEventListener('mousemove', this.mouseListener)
    window.addEventListener('touchstart', this.mouseListener)
    window.addEventListener('resize', this.updateSize);
  }

  keyboardListener = (e) => {
    const {
        state: {
          is_mouse_user
        }
      } = this,
      key = e.code || e.key
    if (is_mouse_user && key === 'Tab') {
      this.setState(
        (state) => {
          return {
            ...state,
            is_mouse_user: false,
            is_keyboard_user: true
          }
        }
      )
    }
  }

  mouseListener = () => {
    const {
      state: {
        is_keyboard_user
      }
    } = this

    if (is_keyboard_user) {
      this.setState(
        (state) => {
          return {
            ...state,
            is_mouse_user: true,
            is_keyboard_user: false
          }
        }
      )
    }
  }

  get is_widget () {
    return /\/widgetpage(\/|\?|$)/.test(window.location.pathname)
  }

  updateSize = (e) => {
    const data = mobile_sizes();

    this.setState(state => {
      return {
        ...state,
        ...data
      }
    });
  }

  static propTypes = {
    lol: deprecatedPropType(
      PropTypes.bool,
      'Fck'
    )
  }

}
